import { render, staticRenderFns } from "./ministry-update.vue?vue&type=template&id=73631b3c"
import script from "./ministry-update.vue?vue&type=script&lang=js"
export * from "./ministry-update.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports